var _mask, _g, _mask2, _g2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H14V16H2V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4676 16H2.53242C2.23831 16 2 15.7815 2 15.5122V0.487903C2 0.218458 2.23831 0 2.53242 0H13.4676C13.7618 0 14 0.218458 14 0.487903V15.5122C14 15.7815 13.7618 16 13.4676 16",
    fill: "#B9C1C8"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 16,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15H16V17H0V15Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7818 17H0.218305C0.0977627 17 0 16.8891 0 16.7525V15.2475C0 15.1109 0.0977627 15 0.218305 15H15.7818C15.9024 15 16 15.1109 16 15.2475V16.7525C16 16.8891 15.9024 17 15.7818 17",
    fill: "#B9C1C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06919 5.01085H5.05067C5.03543 5.01085 5.02295 4.99837 5.02295 4.98325V2.96461C5.02295 2.94937 5.03543 2.93701 5.05067 2.93701H7.06919C7.08443 2.93701 7.09679 2.94937 7.09679 2.96461V4.98325C7.09679 4.99837 7.08443 5.01085 7.06919 5.01085",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8709 5.01085H8.85231C8.83707 5.01085 8.82471 4.99837 8.82471 4.98325V2.96461C8.82471 2.94937 8.83707 2.93701 8.85231 2.93701H10.8709C10.8862 2.93701 10.8984 2.94937 10.8984 2.96461V4.98325C10.8984 4.99837 10.8862 5.01085 10.8709 5.01085",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06919 9.28759H5.05067C5.03543 9.28759 5.02295 9.27523 5.02295 9.25999V7.24135C5.02295 7.22611 5.03543 7.21375 5.05067 7.21375H7.06919C7.08443 7.21375 7.09679 7.22611 7.09679 7.24135V9.25999C7.09679 9.27523 7.08443 9.28759 7.06919 9.28759",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8709 9.28759H8.85231C8.83707 9.28759 8.82471 9.27523 8.82471 9.25999V7.24135C8.82471 7.22611 8.83707 7.21375 8.85231 7.21375H10.8709C10.8862 7.21375 10.8984 7.22611 10.8984 7.24135V9.25999C10.8984 9.27523 10.8862 9.28759 10.8709 9.28759",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06919 13.7228H5.05067C5.03543 13.7228 5.02295 13.7104 5.02295 13.6952V11.6765C5.02295 11.6613 5.03543 11.6489 5.05067 11.6489H7.06919C7.08443 11.6489 7.09679 11.6613 7.09679 11.6765V13.6952C7.09679 13.7104 7.08443 13.7228 7.06919 13.7228",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8709 13.7228H8.85231C8.83707 13.7228 8.82471 13.7104 8.82471 13.6952V11.6765C8.82471 11.6613 8.83707 11.6489 8.85231 11.6489H10.8709C10.8862 11.6489 10.8984 11.6613 10.8984 11.6765V13.6952C10.8984 13.7104 10.8862 13.7228 10.8709 13.7228",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIconDark);
export default __webpack_public_path__ + "static/media/building-icon-dark.834b5280780dd0e178d285374d9c86ea.svg";
export { ForwardRef as ReactComponent };